import Vue from 'vue'
import Vuex from 'vuex'

// import auth from './modules/auth'
import notification from './modules/notification'
import authOidc from './modules/authOidc'
import financeiro from './modules/financeiro'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    authOidc,
    notification,
    financeiro
  },
  strict: debug,
  plugins: []
})